import { useState, useCallback, useContext } from "react";
import {
  Dropdown,
  SelectableOptionMenuItemType,
  SearchBox,
  Checkbox,
} from "@fluentui/react";
import themeContext from "../../../context/theme/ThemeContext";

const SearchableDropDown = (props) => {
  const {
    dropDownStyle,
    name,
    placeholder,
    className,
    label,
    style,
    isRequired,
    errorMessage,
    isMultiSelect,
    options,
    searchboxProps = {
      autoComplete: "false",
      autoFocus: true,
    },
    onSearchValueChanged,
    onRenderOption,
    selectedKeys,
    onChange,
  } = props;

  const { getThemeColor } = useContext(themeContext);

  const getOptions = useCallback(() => {
    const result = [];
    result.push({
      key: "search",
      text: "",
      itemType: SelectableOptionMenuItemType.Header,
    });

    if(options.length > 0){
      return result.concat([...options]);
    }

    return result.concat([{key:"no options",text:"no options available", disabled:true}]);
  }, [options]);

  const handleRenderOption = useCallback((option, defaultRender) => {
    if (!option) {
      return null;
    }

    if (option.itemType === SelectableOptionMenuItemType.Header && option.key === "search") {
      return (
        <div style={{ paddingTop: "5px", top:"0",position: "fixed", zIndex: "1", backgroundColor:getThemeColor("modal-body"), width:"87%" }}>
          <SearchBox
            {...searchboxProps}
            onChange={(ev, newValue) => {
              if (typeof onSearchValueChanged === "function") {
                onSearchValueChanged(newValue || null);
              }
            }}
            onSearch={(newValue) => {
              if (typeof onSearchValueChanged === "function") {
                onSearchValueChanged(newValue || null);
              }
            }}
            onClear={() => {
              if (typeof onSearchValueChanged === "function") {
                onSearchValueChanged(null);
              }
            }}
          />
        </div>
      );
    }

    if (typeof onRenderOption === "function") {
      return onRenderOption(option, defaultRender);
    }

    if (!defaultRender) {
      return null;
    }

    return defaultRender(option);
    // return (
    //   <div style={{ display: 'flex', alignItems: 'center' }}>
    //     {isMultiSelect && option.checkboxVisibility !== false && (
    //       <Checkbox
    //         checked={selectedKeys.includes(option.key)}
    //         onChange={(e, checked) => {
    //           if (typeof onChange === "function") {
    //             onChange(e, checked, option);
    //           }
    //         }}
    //       />
    //     )}
    //     <span style={{margin:"1px", fontSize:"14px", fontWeight:"400"}}>{option.text}</span>
    //   </div>
    // );
  }, [onSearchValueChanged, onRenderOption, searchboxProps]);

  return (
    <>
      {options.length > 0 ? (
        <Dropdown
          styles={dropDownStyle}
          {...props}
          options={getOptions()}
          onRenderOption={(option, defaultRender) => handleRenderOption(option, defaultRender)}
          name={name}
          placeholder={placeholder}
          className={className}
          label={label}
          style={style}
          required={isRequired}
          errorMessage={errorMessage}
          multiSelect={isMultiSelect}
        />
      ) : 
        <Dropdown
          styles={dropDownStyle}
          {...props}
          options={getOptions()}
          onRenderOption={(option, defaultRender) => handleRenderOption(option, defaultRender)}
          name={name}
          placeholder={placeholder}
          className={className}
          label={label}
          style={style}
        />
      }

    </>
  );
};

export default SearchableDropDown;
